import { gql } from '@apollo/client';

import { EscrowMembershipFragment } from './escrowMemberships.fragment';

export * from './escrowMembershipUpdate.mutation.generated';

export const ESCROW_MEMBERSHIP_UPDATE = gql`
  mutation escrowMembershipUpdate($input: EscrowMembershipUpdateInput!) {
    escrowMembershipUpdate(input: $input) {
      errors
      success
      escrowMembership {
        ...EscrowMembershipFragment
      }
    }
  }
  ${EscrowMembershipFragment}
`;
